import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { FaCode } from "react-icons/fa";
import { GrTrash } from "react-icons/gr";
import { MdOutlineModeEdit } from "react-icons/md";
import ReviewVideosModal from "./ReviewVideosModal";
import EmbeddedModal from "./EmbeddedModal";
import ReviewPlaylistModal from "./ReviewPlaylistModal";
import { toast } from "react-toastify";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert";

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#F1F1EE", // Set background color for header cells
      color: "#000", // Set text color for header cells
      border: "1px solid #E0E0E0", // Add border to header cells
      justifyContent: "center",
    },
  },
  cells: {
    style: {
      border: "1px solid #F1F1EE",
      padding: "10px",
      cursor: "default",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  tableWrapper: {
    style: {
      minHeight: "200px",
    },
  },
};

const ReviewplaylistTable = ({ playlist, getPlaylist }) => {
  const [showVideoModel, setShowVideoModel] = useState(false);
  const [showembedded, setShowembedded] = useState(false);
  const [playlistcode, setPlaylistcode] = useState("");
  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };
  const [pId, setpId] = useState("");

  const handleembeddedShow = (playlistId) => {
    const selected = playlist?.find((p) => p.id === playlistId); // Find the correct playlist
    if (!selected) {
      console.error("Playlist not found");
      return;
    }
    setpId(playlistId);
    setPlaylistcode(selected.code);
    setShowembedded(true);
  };

  useEffect(() => {
    if (showembedded) {
      const selected = playlist?.find((p) => p.id === pId); // Find the correct playlist
      setPlaylistcode(selected.code);
    }
  }, [showembedded, playlist]);

  const handleCloseembbeded = () => {
    setShowembedded(false);
  };
  const handleClose = () => setShowVideoModel(false);
  // const handleShow = () => setShowVideoModel(true);
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [VideoId, setvideoIds] = useState([]);

  // const handleShow = (playlistId) => {
  //   setSelectedPlaylist(playlistId); // Store the selected playlist ID
  //   setShowVideoModel(true);
  //   GetVideoId(playlistId);
  // };

  const handleShow = (playlistId) => {
    const selected = playlist?.find((p) => p.id === playlistId); // Find the correct playlist
    if (!selected) {
      console.error("Playlist not found");
      return;
    }

    setSelectedPlaylist(selected);
    setShowVideoModel(true);
    setvideoIds(selected.videos.map((video) => video.videoId)); // Debugging
  };
  const submit = (id) => {
    confirmAlert({
      title: "Do you really want to delete the Video UGC Playlist?",
      // message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes, delete",
          onClick: () => handledeletePlaylist(id),
        },
        {
          label: "Cancel",
          // onClick: () => alert("Click No")
        },
      ],
    });
  };

  const handledeletePlaylist = async (id) => {
    try {
      const response = await axios.put(
        `  ${process.env.REACT_APP_API_URL_PDP}/api/playlists/delete/${id}`,
        {},
        {
          headers: {
            Authorization: localStorage.getItem("token") || "",
          },
        }
      );
      toast.success("Deleted Successfully");
      getPlaylist();
    } catch (error) {
      console.error("Error deleting playlist:", error);
      toast.error("Failed to delete playlist");
    }
  };

  const columns = [
    {
      name: "Sr",
      selector: (row) => "1",
      sortable: true,
      width: "6%",
    },
    {
      name: "Playlist Name",
      selector: (row) => row.playlistName,
      sortable: true,
    },
    {
      name: "Created at",
      selector: (row) => formatDate(row?.createdAt),
      sortable: true,
    },
    {
      name: "Code",
      selector: (row) => row.code,
      sortable: true,
    },
    {
      name: "Attached Video",
      selector: (row) => row.videoCount,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => {
        return (
          <>
            <div className="d-flex gap-3">
              {/* <button className='btn btn-sm btn-outline-dark' style={{ borderRadius: "100px" }} >Edit</button> */}
              <MdOutlineModeEdit
                size={20}
                onClick={() => handleShow(row.id)}
                style={{ cursor: "pointer" }}
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style={{ cursor: "pointer" }}
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                onClick={() => {
                  handleembeddedShow(row.id);
                }}
              >
                <g clipPath="url(#clip0_1949_6630)">
                  <path
                    d="M20 10.5L15.2858 15.2142L14.1075 14.0358L17.6433 10.5L14.1075 6.96417L15.2858 5.78583L20 10.5ZM2.35667 10.5L5.8925 14.0358L4.71417 15.2142L0 10.5L4.71417 5.78583L5.89167 6.96417L2.35667 10.5ZM8.15667 18H6.38333L11.8433 3H13.6167L8.15667 18Z"
                    fill="#454549"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1949_6630">
                    <rect
                      width="20"
                      height="20"
                      fill="white"
                      transform="translate(0 0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <i
                className="ri-delete-bin-6-line"
                style={{
                  color: "rgba(255, 61, 0, 1)",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  // handledeletePlaylist(row.id);
                  submit(row.id);
                }}
              ></i>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <div className="mt-4">
      <DataTable
        columns={columns}
        data={playlist}
        // data={data} // pagination
        // highlightOnHover
        customStyles={customStyles}
      />
      {showVideoModel && (
        <ReviewPlaylistModal
          show={showVideoModel}
          handleClose={handleClose}
          playlist={playlist}
          VideoId={VideoId}
          selectedPlaylist={selectedPlaylist}
          getPlaylist={getPlaylist}
        />
      )}
      <EmbeddedModal
        embeddedshow={showembedded}
        handleCloseembbeded={handleCloseembbeded}
        id={""}
        playlistcode={playlistcode}
        videoUgc={true}
      />
    </div>
  );
};

export default ReviewplaylistTable;
